import React from 'react';
import './NotEntitledOverlay.css';
import { CenterFrameLayout } from 'Layouts';

const NotEntitledOverlay = ({ selectedMVPD: { selectedMVPD } }) => {
  const isYouTube = selectedMVPD.mvpdId === 'YouTubeTV';

  const providerName = isYouTube ? 'YouTube TV/YouTube' : selectedMVPD.name;
  const providerHelpLink = selectedMVPD.helpLink;
  const titleString = `Your ${providerName} subscription does not include Fox Nation`;

  let secondaryText;
  if (isYouTube) {
    secondaryText = (
      <>
        {`To add Fox Nation to your subscription:`}
        <p>
          YouTube subscribers please visit <a href={`https://youtube.com/foxnation`}>youtube.com/foxnation</a>
          <br />
          YouTube TV subscribers please visit <a href={`https://${providerHelpLink}`}>{providerHelpLink}</a>
        </p>
      </>
    );
  } else {
    secondaryText = (
      <>
        {`To add Fox Nation to your ${providerName} subscription, please visit `}
        <a href={`https://${providerHelpLink}`}>{providerHelpLink}</a>
      </>
    );
  }

  return (
    <CenterFrameLayout customClass="mvpdNotIncludedTitle" noPanel title={titleString}>
      <div className="notEntitledPanel">
        <div className="notEntitledPanelWrapper">
          <div className="secondaryText">{secondaryText}</div>
          <a href="https://nation.foxnews.com/" className="pillButton">
            Back to Fox Nation
          </a>
        </div>
      </div>
    </CenterFrameLayout>
  );
};

export default NotEntitledOverlay;
